export const measurements: any = {
  co2_pressure_compensated: 'ppm',
  barometric_pressure: 'hPa',
  relative_humidity: '%',
  temperature: '˚C',
  rem_batt_capacity_display: '%',
  rem_batt_capacity_sensor: '%',
  inactivityTimeout: "sec",
}